import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import styles from "./LoadingIcon.module.css";
import src from "./LoadingLottie.json?url";

export function LoadingAnimation() {
    return <DotLottieReact className={styles.player} src={src} loop autoplay speed={1} />;
}
